<ion-button
  *mobxAutorun="{ detach: true }"
  [fill]="isSelected ? 'solid' : 'clear'"
  [color]="isSelected ? 'primary' : 'medium'"
  [disabled]="disabled"
  (click)="changeBehaviorSubject.next(value)"
>
  <ng-content> </ng-content>
</ion-button>
